import {AxiosError} from 'axios';
import {POST_SEARCH_APPROVERS_URL} from 'web-library/constants/apiUrls';
import {
  SearchApproversRequest
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import {ConfigurationType} from 'web-library/models/DropDown';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: ConfigurationType[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSearchApprovers = ({onError, onSuccess}: Input = {}) => {
  const postSearchApprovers = async (reqBody: SearchApproversRequest) => {
    const res = await axiosClient.post<ConfigurationType[]>(POST_SEARCH_APPROVERS_URL(), reqBody);

    return res.data;
  };

  return useCustomMutation(postSearchApprovers, {
    onSuccess,
    onError,
  });
};
